import { AppInput, AppPasswordInput, Button } from "components";
import AuthLayout from "layouts/AuthLayout";
import React, { useState } from "react";
import { ApiService } from "services";
import { toast } from "react-hot-toast";
import { Router } from "utils/route";

export default function SignUp() {
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [loader, setLoader] = useState(false);

  const { route } = Router();

  const loginAdmin = async () => {
    if (username && password) {
      setLoader(true);
      try {
        const data = await ApiService.loginUser({
          email: username,
          password: password,
        });
        console.log(data);
        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
        if (
          err?.response?.data?.data?.passwordChanged === "False" &&
          err?.response?.data?.data?.userId
        ) {
          console.log("redirect otp");
          localStorage.setItem("user_id", err?.response?.data?.data?.userId);

          route("/otp");
        } else {
          console.log("redirect login");
        }
      }
    }
  };
  return (
    <div>
      <AuthLayout
        submit={(e) => {
          e.preventDefault();
          console.log("eeee");
          loginAdmin();
        }}
        title="Welcome to Payarena Exchange Monitoring System"
      >
        <AppInput
          onChange={(e) => {
            setUsername(e.target.value);
          }}
          placeholder="Enter your Email"
        />
        <AppPasswordInput
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder="Password"
        />
        <Button loading={loader} disabled={loader} placeholder="Proceed" />
      </AuthLayout>
    </div>
  );
}
